import { defineComponent as _defineComponent } from 'vue'
import { useAuthStore } from '@/app/store/authModule';
import { useToast } from 'ah-common-lib/src/toast/Toast';
import { VButton } from 'ah-common-lib/src/common/components';
import { useRequestManager } from 'ah-common-lib/src/requestManager/useRequestManager';

export default /*#__PURE__*/_defineComponent({
  __name: 'DevSettingsView',
  setup(__props) {

const appVersion = window.VUE_APP_VERSION;

const commitHash = window.VUE_APP_COMMIT_HASH;

const authStore = useAuthStore();

const toast = useToast();

const requestManager = useRequestManager().manager;

function invalidateSession() {
  authStore.authToken = 'INVALID';
  toast.success('Session invalidated');
}

function invalidateRefreshToken() {
  authStore.refreshToken = 'INVALID';
  toast.success('Refresh token invalidated');
}

function refreshSession() {
  requestManager.sameOrNewPromise(
    'refreshSession',
    () =>
      authStore.refreshSession().then(() => {
        authStore.isLoggedIn ? toast.success('Session refreshed') : toast.error('Session in error, logged out user');
      }),
    authStore.authToken
  );
}

return { __sfc: true,appVersion, commitHash, authStore, toast, requestManager, invalidateSession, invalidateRefreshToken, refreshSession, VButton }
}

})